import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const CompanyAsset = React.lazy(() =>
  import("@/pages/companyAssets/hr/CompanyAssets")
);
const ITInfraCompanyAssets = React.lazy(() =>
  import("@/pages/companyAssets/itInfra/ITInfraAsset")
);

const EmployeeAssets = React.lazy(() =>
  import("@/pages/companyAssets/employee/EmployeeAssets")
);
const CompanyAssets = [
  {
    path: "assets",
    element: (
      <SuspenseWrapper>
        <CompanyAsset />
      </SuspenseWrapper>
    ),
  },
  {
    path: "EmployeeAssets",
    element: (
      <SuspenseWrapper>
        <EmployeeAssets />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ITInfraCompanyAssets",
    element: (
      <SuspenseWrapper>
        <ITInfraCompanyAssets />
      </SuspenseWrapper>
    ),
  },
];

export default CompanyAssets;
